//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {createPrintTemplate, deletePrintTemplate, searchPrintTemplate} from '../../../api/printTemplate';
import {getProjectStages} from '../../../api/project';
import fileUploader from '../../../views/common-components/file-uploader';

export default {
  name: 'project-print-view',
  components: {
    fileUploader
  },
  props: {
    projectId: {
      type: Number, required: true
    }
  },
  data() {
    const vm = this;
    return {
      loading: false,
      saving: false,
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      searchInput: {},
      list: [],
      columns: [
        {type: 'index', align: 'center', width: 60},
        {title: '模板名称', key: 'templateName', align: 'center'},
        {title: '模板类型', key: 'businessTypeStr', align: 'center'},
        // { title: '项目名称', key: 'projectName', align: 'center' },
        {title: '项目分期', key: 'projectStages', align: 'center'},
        {title: '创建日期', key: 'creationTimeStr', align: 'center'},
        {
          title: '是否有效', key: 'isActive', align: 'center',
          render: (h, params) => {
            const row = params.row;
            return h('span', row.isActive ? '是' : '否')
          }
        },
        {title: '操作', align: 'center', slot: 'actions'}
      ],
      createPrintTemplateModal: false,
      printTemplateDto: {
        // isActive: true,
        printTemplateAttach: {}
      },
      rules: {
        projectId: [{required: true, message: '请选择项目', type: 'number', trigger: 'change'}],
        businessType: [{required: true, message: '请选择模板类型', type: 'number', trigger: 'change'}],
        templateName: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
        projectName: [{required: true, message: '请选择项目', trigger: 'blur'}]
      },
      projectStages: []
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.getPage();
    },
    pageSizeChange(size) {
      this.pageSize = size;
      this.getPage();
    },
    getPage() {
      this.searchInput.projectId = this.projectId;
      this.searchInput.maxResultCount = this.pageSize;
      this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
      this.loading = true;
      searchPrintTemplate(this.searchInput).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
      }).finally(() => {
        this.loading = false;
      });
    },
    onEdit(row) {
      this.printTemplateDto = {};
      this.printTemplateDto = JSON.parse(JSON.stringify(row));
      // if (!this.printTemplateDto.printTemplateAttach) {
      //   this.printTemplateDto.printTemplateAttach = {}
      // }
      this.createPrintTemplateModal = true;
    },
    onSave() {
      // console.log(this.printTemplateDto)
      // return
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;
          createPrintTemplate(this.printTemplateDto).then(res => {
            this.$Notice.success({
              title: '提示',
              desc: '保存成功'
            });
            this.createPrintTemplateModal = false;
            this.getPage();
          }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    onCancel() {
      this.$refs.form.resetFields();
      this.createPrintTemplateModal = false;
    },
    onHandleDel(row) {
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          deletePrintTemplate(row.id).then(res => {
            this.getPage();
            this.$Notice.success({
              title: '提示',
              desc: '操作成功'
            });
          });
        }
      });
    },

    getProjectStages() {
      getProjectStages(this.projectId).then(res => {
        this.projectStages = [];
        this.projectStages.push(...res.data.result.items);
        console.log(this.projectStages);
      });
    }

  },
  created() {
    this.getPage();
    this.getProjectStages();
  }
};
